<style lang="stylus" scoped>
@import './cardMap.stylus';

.title {
  span {
    margin: 0px 15px;
    border-bottom: 3px solid transparent;
    color: #999999;
    display: inline-block;
    height: auto;
    line-height: 2;
  }

  span.active {
    border-color: #336CAF;
    color: #326DAF;
  }
}

.mark {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  background: rgba(0, 0, 0, 0.7);
  z-index: 100;

  .circle {
    margin: auto;
  }
}

.changeTime {
  font-size: 20px;
  color: #333;
  font-weight: bold;
}

.span {
  color: #999;
  font-size: 14px;
  font-weight: normal;
}
</style>

<template>
  <div>
    <div class="home-main">
      <!-- <exportDate v-if="showExport" @hideExport="hideExport1" :moduleName="moduleName"/> -->
      <dimension-dialog
        v-if="showExport"
        @hideExport="hideExport1"
        :moduleName="moduleName"
        :autoChunkMonth="true"
        :tab="dataType1"
      />
      <div class="map-search">
        <div class="map-title">
          <el-row>
            <CardHeader :title="titleTie" />
            <el-select
              v-model="fuelType"
              @change="changeFuelType"
              style="width:150px;position:absolute;right:92px;top:2px"
              placeholder="请选择燃油类型"
            >
              <el-option
                v-for="(item, index) in fuelTypeList"
                :label="item.label"
                :value="item.value"
                :key="index"
              />
            </el-select>
            <el-button
              style="position:absolute;right:20px;top:22px;"
              @click="exportDate"
              v-show="hideExport"
              >导出</el-button
            >
          </el-row>
        </div>
        <map-data-table
          :areaList="areaList"
          v-if="areaList && areaList.length > 0"
          :changeCity="changeCity"
        ></map-data-table>
      </div>
      <div class="map-data">
        <div class="changeTime">
          <el-row>
            <el-col :span="16" :offset="3">
              货运平台车辆途经{{ dataType ? dataType : '全国' }}车次统计 -
              <!-- <el-date-picker v-model="monTime" type="month" placeholder="选择月" @change="changeTime"></el-date-picker> -->
              <dimension-popover
                ref="objDimensionPopover"
                :isMapValue="true"
                :dimObj="dimObj"
                :change="changeDimension"
                :showBottomButton="false"
                :isItemBindClick="true"
              />
            </el-col>
            <el-col
              v-show="dataType && jurisdiction(410)"
              :span="16"
              :offset="3"
              class="span"
              style="cursor:pointer"
              @click.native="toDetail({ title: dataType, code: provinceCode })"
              >查看途经{{ dataType ? dataType : '全国' }}地区车次统计></el-col
            >
          </el-row>
        </div>
        <div class="map-area">
          <home-map
            :mapRangeList="mapRangeList"
            :dataItem="dataItem"
            :title="title"
          ></home-map>
          <mapBox v-if="showtip" />
        </div>
        <map-card :cardItem="cardData" :total="total"></map-card>
      </div>
    </div>
    <div class="bottom-top">
      <h4>
        <img src="../../../assets/images/title.png" />
        <span>说明</span>
      </h4>
      <div>1.车辆途经省：重载货车行驶运营的省份。</div>
      <div>2.车辆注册省：重载货车登记入网的省份，即车籍地。</div>
      <div>3.车次统计：统计时间内，车辆途经本省次数（进出算一次）汇总。
      【举例】点击车辆途经省“北京”，页面显示车次数含义为：①合计XX次：全国各地重载货车途经北京共XX次；②北京XX次：北京车牌的重载货车途经北京为XX次；③河北XX次：河北车牌的重载货车途经北京为XX次。以此类推。</div>
      <div>4.统计频率：按月统计，每月6日更新上月数据。</div>
      <div>5.下一级页面：点击车辆途经省具体省份，点击“查看途经XX地区车次统计”，可进入车辆途经地区页面。</div>
    </div>
  </div>
</template>
<script>
import SearchBtn from '@/components/searchBtn'
import homeMap from './components/map.vue'
import mapDataTable from './components/mapDataTable.1.vue'
import mapCard from './components/mapCard.vue'
import CardHeader from './components/cardHeader.vue'
import https from '@/api/freight.js'
import http from '@/api/cardData'
import cityData from './map-data/get-city-value.js'
import geoData from './map-data/get-geography-value.js'
import Cookies from 'js-cookie'
import exportDate from '@/components/exportDate'
import { hideExport } from '@/utils/tools'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
import dimensionDialog from '@/components/exportDate/daphne/dialog.vue'
import Util from '@/utils/util'
import get from 'lodash/get'
import set from 'lodash/set'
import each from 'lodash/each'
import { getFuelTypeList, getFuelTypeCode } from '@/utils/dictionary'
var now = new Date()
now.setMonth(now.getMonth())
export default {
  name: 'home',
  components: {
    homeMap,
    mapDataTable,
    mapCard,
    SearchBtn,
    CardHeader,
    exportDate,
    dimensionDialog,
    dimensionPopover
  },

  data() {
    let fuelTypeList = getFuelTypeList()
    let value4 = Util.lastTime(new Date())
    let arr = value4.split('-')
    let dimObj = {
      year: arr[0],
      month: arr[1],
      type: '0'
    }
    return {
      dataType1: 0, //车次
      fuelType: '',
      fuelTypeList,
      hideExport: hideExport,
      showtip: false,
      titleTie: '途经各省运营车次统计',
      showExport: false, //控制批量导出
      moduleName: 'vehicleWayCount',
      cityData: [],
      areaList: [], //省列表
      dataType: '', //点击省份详情列表
      title: 0, //地图标题
      tab: 0,
      dataItem: [],
      mapRangeList: [],
      provinceCode: '',
      monTime: now, // 默认月份
      cardData: [],
      total: 0,
      countryIs: 0,
      dimObj,
      firstLoaded:1,
      value4
    }
  },
  watch: {
    timeSection: function(value, oldValue) {
      this.initData()
    }
  },
  computed: {
    allTab: function() {
      return this.$store.state.app.tab
    },
    titleArr: function() {
      return this.$store.state.app.titleArr
    }
  },
  created() {
    // this.$refs.homeMap.get();
    this.getendMonth()
    this.initData()
    this.getData()
    console.log(this.fuelTypeList, 'fuelTypeList')
  },

  methods: {
    changeFuelType() {
      // this.initData()
      this.getData()
    },
    changeDimension(e) {
      if (e.isOk) {
        let type = e.type
        let arr = get(this, ['dimsTitle', type], [])
        each(arr, (title, index) => {
          if (title) {
            set(this, ['titleArr', index, 'title'], title)
          }
        })
        this.value4 = e.year + '-' + e.month
        this.dimObj.year = e.year
        this.dimObj.month = e.month
        this.dimObj.type = type
        this.changeTime()
      }
    },
    toDetail({ title, code }) {
      let that = this
      this.$router.push({
        name: 'carTrainsDetail',
        query: {
          title: title,
          code: code,
          yearMonth: that.endMonth,
          proCode: that.provinceCode,
          countryIs: that.countryIs
        }
      })
    },
    // 取消导出
    hideExport1() {
      this.showExport = false
    },
    getendMonth() {
      let that = this
      that.endMonth = this.dimObj.year + this.dimObj.month
    },
    //导出
    exportDate() {
      this.showExport = true
    },
    changeTime() {
      let that = this
      console.log(this.value4, this.dimObj, '查询')
      that.endMonth = this.dimObj.year + this.dimObj.month
      this.getData()
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    initData() {
      let that = this
      // http[that.tab].timeChange().then(e => {
      //   let data = e.data
      //   console.log(data.areaList)
      //   that.areaList = data.areaList
      // })
      https
        .getProList({
          phone: Cookies.get('user')
        })
        .then(e => {
          that.areaList = e.data
        })
    },
    getData() {
      let type = get(this, 'dimObj.type', '0')

      let that = this
      console.log(this.value4, this.dimObj, '查询')

      https
        .carTrains({
          dataType: that.dataType1,
          timeType: type,
          fuelType: getFuelTypeCode(that.fuelType),
          yearMonth: that.endMonth,
          proCode: that.provinceCode,
          countryIs: that.countryIs,
          firstPageLoad:that.firstLoaded
        })
        .then(e => {
          let data = e.data
          let tempArr = [
            '第1-3名',
            '第4-7名',
            '第8-12名',
            '第13-18名',
            '第19-31名'
          ] //地图图例汉字
          let time = e.data.time
          that.monTime = time
          that.endMonth = time.replace('-', '')
          // that.mapRangeList = [...data.mapRangeList]
          that.total = data.sum
            if(this.firstLoaded){
            this.firstLoaded=0;
              that.value4=e.data.time;
              let arr = that.value4.split('-')
              set(this,"dimObj.year",arr[0])
              set(this,"dimObj.month",arr[1])
              this.$refs.objDimensionPopover.setCtrlValue();
              // that.changeTime()
          }

          if (data.sum == 0 || data.sum == null) {
            that.dataItem = []
            that.mapRangeList = [{ end: 0, start: 0, label: '无' }]
            this.showtip = true
            return
          } else {
            this.showtip = false
            if (e.data.mapRangeList.length) {
              for (let i = 0; i < e.data.mapRangeList.length; i++) {
                // if (e.data.mapRangeList[i].end == -1) {
                e.data.mapRangeList[i].label = tempArr[i]
                //     e.data.mapRangeList[i].start + ' 以上'
                //   delete e.data.mapRangeList[i].end
                // }
              }
              that.mapRangeList = [...e.data.mapRangeList]
              that.dataItem = that.handleSeriesData({
                data: e.data.list
              })
            }
            that.cardData = [...data.list]
          }
        })
    },
    handleSeriesData({ index = 0, data }) {
      let that = this
      let arrs = JSON.stringify(data)
      let handleArr = JSON.parse(arrs)
      handleArr.forEach(e => {
        e.name = e.registProvince
        if (index == 0) {
          e.value = e.countNum
        } else if (index == 1) {
          e.value = e.time_0_6
        } else if (index == 2) {
          e.value = e.time_6_12
        } else if (index == 3) {
          e.value = e.time_12_18
        } else if (index == 4) {
          e.value = e.time_18_24
        } else {
          e.value = e.countNum
        }
      })
      return handleArr
    },

    changeCity(index) {
      let that = this
      if (index == -1) {
        that.provinceCode = ''
        that.dataType = ''
        that.countryIs = 0
      } else {
        let areaList = this.areaList
        that.provinceCode = areaList[index].provinceCode
        that.dataType = areaList[index].provinceName
        that.countryIs = 1
      }
      this.getendMonth()
      this.getData()
    },
    childData() {
      var convertData = function(data) {
        let res = []
        let len = data.length
        for (var i = 0; i < len; i++) {
          var geoCoord = geoData[data[i].name]
          if (geoCoord) {
            res.push({
              name: data[i].name,
              value: geoCoord.concat(data[i].value)
            })
          }
        }
        return res
      }
    }
  }
}
</script>
